import React from 'react';
import styles from './index.module.less';
import classNames from 'classnames';

const Index: React.FC<{ title: string; type: 'jobs' | 'games' | 'env' }> = ({
  title,
  type,
}) => {
  return (
    <div
      className={classNames([
        styles.mj_moduleTitle_container,
        styles[`mj_moduleTitle_${type}`],
      ])}>
      <div>{title}</div>
      <div>Manjuu Games</div>
    </div>
  );
};

export default Index;
